export function getItemFromStorage(itemName: string) {
  let item = sessionStorage.getItem(itemName);
  if (!item) item = localStorage.getItem(itemName);

  return item;
}

export function setTokenToStorage(rememberMe: boolean, token: any) {
  if (rememberMe === false) sessionStorage.setItem("satellizer_token", token);
  else localStorage.setItem("satellizer_token", token);
}

export function getTokenFromStorage() {
  const token = getItemFromStorage("satellizer_token");
  return token;
}

export function clearStorage() {
  sessionStorage.removeItem("satellizer_token");
  sessionStorage.removeItem("useSubscription");
  localStorage.removeItem("satellizer_token");
}
